import { useForm as createUseForm } from "@ant-design-vue/use";
import { Col, Modal, notification, Row } from "ant-design-vue";
import lodash from "lodash";
import moment from "moment";
import { defineAsyncComponent, toRaw } from "vue";
import { setIsLoading as setIsLoadingApp } from "../../../../app.logic";
import { callAddressType, createForm as createFormAddress } from "../../../../components/address/address.logic";
import { setAppPageHeader } from "../../../../components/layout/app-layout/app-layout.logic";
import i18n from "../../../../i18n";
import store from "../../../../store";
import {
    createButton,
    createButtonActive,
    createButtonArchive,
    createButtonCreate,
    createButtonDelete,
    createButtonEdit,
    createButtonSave,
    createButtonView
} from "../../../../utils/button";
import {
    checkAttribute,
    initUseForm,
    onClickActive,
    onClickActiveAll,
    onClickArchive,
    onClickArchiveAll,
    onClickCreate,
    onClickDelete,
    onClickDeleteAll,
    onClickEdit,
    onClickView,
    watchRulesChildren
} from "../../../../utils/form";
import { createLoading } from "../../../../utils/loading";
import { has } from "../../../../utils/menu-context";
import {
    createAppPageHeaderTop,
    createManageActive,
    createManageArchive,
    createManageDelete,
    createManageExportCsv,
    createManageExtraCreate,
    createManageSelect,
    createPage,
    createRowActionEdit,
    createRowActionOpenUrl, createRowActionReStatus,
    createRowActionView
} from "../../../../utils/page";
import { flatWhereGroup } from "../../../../utils/search";
import { required, requiredWhen, validateError } from "../../../../utils/validate";
import { openModalForm as openModalFormConfirmReceive } from "../../storage-location/request/modal/confirm-receive.logic";
import { openModalForm as openModalFormConfirmRequest } from "../../storage-location/request/modal/confirm-request.logic";
import { callRequestDoc, callRequestStatus, callRequestType } from "../../storage-location/request/request.section";
import { callRequestDocGenType, callUser, callUserCompanyMe } from "../../storage-location/request/requestor/requestor.section";
import { createForm as createFormHc } from "../hc/hc.logic";
import { openModalForm as openModalFormConfirmConfirm } from "./modal/confirm-confirm.logic";
import { createConditionAction, createConditionForm } from "./request.condition";
import { callHcAttachment, callLicenseHcTerms, createColumns, createField } from "./request.section";

const CIcon = defineAsyncComponent(() => import("../../../../components/icon/CIcon"));

export const { isLoading, setIsLoading } = createLoading();
export const actionPrefix = "resource/v1/transaction/request";

export const callRequest = ({ form }) => store.dispatch(`${actionPrefix}/request`, { data: form });
export const callSearch = ({ criteria }) => store.dispatch(`${actionPrefix}/search`, { criteria });
export const callActive = ({ id }) => store.dispatch(`${actionPrefix}/active`, { id });
export const callArchive = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id });
export const callDelete = ({ id }) => store.dispatch(`${actionPrefix}/delete`, { id, config: { params: { isHardDelete: true } } });
export const callActiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/activeAll`, { ids });
export const callArchiveAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids });
export const callDeleteAll = ({ ids }) => store.dispatch(`${actionPrefix}/deleteAll`, { ids, config: { params: { isHardDelete: true } } });
export const callChanges = ({ id, criteria }) => store.dispatch(`${actionPrefix}/changes`, { id, criteria });
export const callReStatus = ({ data }) => store.dispatch(`${actionPrefix}/reStatus`, { data });
export const callReportHc = ({ data }) => store.dispatch(`${actionPrefix}/reportHc`, { data });
export const callConfirmHc = ({ data }) => store.dispatch(`${actionPrefix}/confirmHc`, { data });

export const onSearch = ({ props, page, state }) => {
    const where = page.where || [];
    const sort = page.sort || [];
    const customWhere = lodash.cloneDeep(where);
    const companyNameThIndex = customWhere.findIndex(d => d.name === "refHcTemp.refUserCompany.companyNameTh");
    if (companyNameThIndex !== -1) {
        const companyNameThWhere = customWhere[companyNameThIndex];
        customWhere.splice(
            companyNameThIndex,
            1,
            {
                openBucket: true,
                name: "refHcTemp.refUserCompany.companyNameTh",
                type: "String",
                operator: "like",
                value: companyNameThWhere.value
            },
            {
                logic: "OR",
                closeBucket: true,
                name: "refHcTemp.refUserCompany.fullNameTh",
                type: "String",
                operator: "like",
                value: companyNameThWhere.value
            }
        );
    }
    const isWaitConfirmIndex = customWhere.findIndex(d => d.name === "isWaitConfirm");
    if (isWaitConfirmIndex !== -1) {
        const isWaitConfirmWhere = customWhere[isWaitConfirmIndex];
        if (isWaitConfirmWhere?.value === true || isWaitConfirmWhere?.value === "true") {
            customWhere.splice(isWaitConfirmIndex, 1,
                { openBucket: true, name: "refHcTemp.isConfirm", type: "Boolean", operator: "=", value: true },
                { closeBucket: true, name: "refStatus.key", type: "String", operator: "=", value: "waitApprove" }
            );
        } else {
            customWhere.splice(isWaitConfirmIndex, 1);
        }
    }
    const isWaitInspectionIndex = customWhere.findIndex(d => d.name === "isWaitInspection");
    if (isWaitInspectionIndex !== -1) {
        const isWaitInspectionWhere = customWhere[isWaitInspectionIndex];
        if (isWaitInspectionWhere?.value === true || isWaitInspectionWhere?.value === "true") {
            customWhere.splice(isWaitInspectionIndex, 1,
                { openBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }, // 1
                { name: "refStatus.key", type: "String", operator: "=", value: "waitApprove" },
                // { openBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" }, // 2
                { openBucket: true, name: "refHcTemp.isConfirm", type: "Boolean", operator: "=", value: null },
                { closeBucket: true, logic: "OR", name: "refHcTemp.isConfirm", type: "Boolean", operator: "=", value: false },
                { closeBucket: true, constant: true, name: "1", type: "String", operator: "=", value: "1" } // 1
            );
        } else {
            customWhere.splice(isWaitInspectionIndex, 1);
        }
    }
    setIsLoading(true);
    window.onSearch?.({ page });
    return callSearch({ criteria: { ...page, data: [], where: [...customWhere, ...createWhereFor({ props })], sort } })
        .then(page => (state.page = { ...page, where, sort }))
        .finally(() => setIsLoading(false));
};

export const createWhereFor = ({ props }) => {
    const { menuContext } = props;
    const whereGroup = [];
    const userInfo = store.state.resource.auth.info?.user;
    whereGroup.push([{ name: "createBy", type: "String", operator: "=", value: userInfo.username }]);
    if (has({ menuContext, key: "forRequest" })) {
        whereGroup.push([{ name: "refHcTemp.refUser.username", type: "String", operator: "=", value: userInfo.username }]);
        if (userInfo.isCeo) {
            whereGroup.push([{ name: "refHcTemp.refUserCompany.id", type: "UUID", operator: "=", value: userInfo?.refParent?.id || userInfo?.id }]);
        }
    }
    if (has({ menuContext, key: "forReceive" })) {
        whereGroup.push([
            { name: "refStatus.key", type: "String", operator: "!=", value: "draft" },
            { name: "refDepartment.id", type: "UUID", operator: "=", value: userInfo.refDepartment?.id }
        ]);
    }
    return [{ name: "refRequestDoc.key", type: "String", operator: "=", value: "23" }, ...flatWhereGroup({ where: whereGroup, logic: "OR" })];
};

export const createSearchOneCriteria = ({ props, id, forLog }) => {
    if (!forLog) {
        return {
            select: ["**", "refHc.id", "refHc.approveCode", "refHc.refUserCompany.*", "refHc.refUserCompany.refPersonType.*", "refHcTemp.**", "refHcTemp.refUserCompany.**", "refHcTemp.refUser.**", "refHcTemp.refInform.**", "refHcTemp.refInform.refInspection.refSequestrate.*"],
            page: 0,
            size: 1,
            where: [{ name: "id", type: "UUID", operator: "=", value: id }, ...createWhereFor({ props })],
            children: [
                {
                    name: "refHcTemp.refUserCompany.addresses",
                    select: ["*"],
                    page: 0,
                    size: 1,
                    where: [{ name: "refAddressType.key", type: "String", operator: "=", value: "1" }]
                },
                {
                    name: "refHcTemp.refUser.addresses",
                    select: ["*"],
                    page: 0,
                    size: 1,
                    where: [{ name: "refAddressType.key", type: "String", operator: "=", value: "1" }]
                },
                {
                    name: "refHcTemp.refInform.requests",
                    asName: "refHcTemp.refInform.lastRequestApprove",
                    select: ["*"],
                    page: 0,
                    size: 1,
                    where: [{ name: "refStatus.key", type: "String", operator: "=", value: "approve" }],
                    sort: [{ name: "createDate", type: "DESC" }],
                    children: [
                        {
                            name: "statuses",
                            asName: "lastStatusApprove",
                            select: ["**"],
                            page: 0,
                            size: 1,
                            where: [{ name: "refStatus.key", type: "String", operator: "=", value: "approve" }],
                            sort: [{ name: "createDate", type: "DESC" }]
                        }
                    ]
                },
                {
                    name: "refHcTemp.addresses",
                    select: ["**"],
                    page: 0,
                    size: 1,
                    where: [{ name: "refAddressType.key", type: "String", operator: "=", value: "1" }]
                },
                {
                    name: "statuses",
                    asName: "lastStatus.draft",
                    select: ["**"],
                    page: 0,
                    size: 1,
                    where: [{ name: "refStatus.key", type: "String", operator: "=", value: "draft" }],
                    sort: [{ name: "createDate", type: "DESC" }]
                },
                {
                    name: "statuses",
                    asName: "lastStatus.waitReceive",
                    select: ["**"],
                    page: 0,
                    size: 1,
                    where: [{ name: "refStatus.key", type: "String", operator: "=", value: "waitReceive" }],
                    sort: [{ name: "createDate", type: "DESC" }]
                },
                {
                    name: "statuses",
                    asName: "lastStatus.waitApprove",
                    select: ["**"],
                    page: 0,
                    size: 1,
                    where: [{ name: "refStatus.key", type: "String", operator: "=", value: "waitApprove" }],
                    sort: [{ name: "createDate", type: "DESC" }]
                },
                {
                    name: "statuses",
                    asName: "lastStatus.approve",
                    select: ["**"],
                    page: 0,
                    size: 1,
                    where: [{ name: "refStatus.key", type: "String", operator: "=", value: "approve" }],
                    sort: [{ name: "createDate", type: "DESC" }]
                },
                {
                    name: "statuses",
                    asName: "lastStatus.forRequestRemark",
                    select: ["**"],
                    page: 0,
                    size: 1,
                    where: [
                        {
                            name: "refStatus.key",
                            type: "String",
                            operator: "in",
                            value: ["draft", "reEditOfficer", "reEditAuthority", "reEditCustoms"]
                        }
                    ],
                    sort: [{ name: "createDate", type: "DESC" }]
                },
                {
                    name: "statuses",
                    asName: "lastStatus.forReceiveRemark",
                    select: ["**"],
                    page: 0,
                    size: 1,
                    where: [
                        {
                            name: "refStatus.key",
                            type: "String",
                            operator: "in",
                            value: ["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment", "approve", "notApprove"]
                        }
                    ],
                    sort: [{ name: "createDate", type: "DESC" }]
                }
            ]
        };
    } else {
        return {
            select: [],
            page: 0,
            size: 1,
            where: [{ name: "id", type: "UUID", operator: "=", value: id }],
            children: []
        };
    }
};

export const onClickSave = ({ props, data, refs, state, formParams, successText }) => {
    const { viewOnly, routerPrefix } = props;
    return validate({ props, data, refs }).then(() => {
        setIsLoadingApp(true);
        return callRequest({ form: { ...data.useForm.modelRef, ...formParams } })
            .finally(() => setIsLoadingApp(false))
            .then(record => {
                if (successText) notification["success"]({ message: successText });
                if (viewOnly) initForm({ props, data, refs, state });
                else onClickView({ record, routerPrefix });
            });
    });
};

export const validate = ({ props, data, refs }) => {
    const { menuContext } = props;
    const rulesTop = createRulesTop({ props, data, refs });
    const rules1 = createRulesTab1({ props, data, refs });
    const rules2 = createRulesTab2({ props, data, refs });
    const rules3 = createRulesTab3({ props, data, refs });
    let tabKey = null;
    return data.useForm
        .validate(Object.keys(rulesTop))
        .then(() => {
            tabKey = "Requestor";
            return data.useForm.validate(Object.keys(rules1));
        })
        .then(() => {
            tabKey = "HcInfo";
            return data.useForm.validate(Object.keys(rules2));
        })
        .then(() => {
            tabKey = "Attachment";
            return data.useForm.validate(Object.keys(rules3));
        })
        .catch(error => {
            if (tabKey) {
                menuContext.tabKey = tabKey;
            }
            validateError({ error });
            throw error;
        });
};

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef), isSave: true }))
        .catch(error => {
            validateError({ error });
            throw error;
        });
};

export const createFormTitle = ({ data }) => {
    const modelRef = data.useForm.modelRef;
    return modelRef.id ? `${modelRef.refRequestDoc?.value} (${modelRef.refStatus?.attribute?.actionHcText})` : i18n.global.t("button.create");
};

export const createForm = () => {
    return {
        model: null,
        refModelId: null,
        refModelTempId: null,
        refRequestType: null,
        refRequestDoc: null,
        refStatus: null,
        draftCode: null,
        requestCode: null,
        refDepartment: null,
        isSignCa: null,
        refHc: null,
        refHcTemp: { ...createFormHc() },
        lastStatus: {
            draft: [{ remark: null, statusDatetime: null }],
            waitReceive: [{ remark: null, statusDatetime: null }],
            waitApprove: [{ remark: null, statusDatetime: null }],
            approve: [{ remark: null, statusDatetime: null }],
            forRequestRemark: [{ remark: null, statusDatetime: null }],
            forReceiveRemark: [{ remark: null, statusDatetime: null }]
        }
    };
};

export const createRules = ({ props, data, refs, key }) => {
    return {
        ...createRulesTop({ props, data, refs, key }),
        ...createRulesTab1({ props, data, refs, key }),
        ...createRulesTab2({ props, data, refs, key }),
        ...createRulesTab3({ props, data, refs, key })
    };
};

export const createRulesTop = ({ data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return {
        [`${prefix}refDocGenType`]: [required],
        [`${prefix}requestCode`]: [requiredWhen({ when: () => ["2"].includes(model.refDocGenType?.key) })],
        [`${prefix}refHcTemp.approveCode`]: [requiredWhen({ when: () => ["2"].includes(model.refDocGenType?.key) })],
        [`${prefix}refRequestType`]: [required],
        [`${prefix}refHc`]: [requiredWhen({ when: () => ["2", "3", "4"].includes(model.refRequestType?.key) })],
        [`${prefix}lastStatus.forRequestRemark.0.remark`]: [requiredWhen({ when: () => !model.isOfficerCreate && ["2", "4"].includes(model.refRequestType?.key) && (!model.id || ["draft", "reEditOfficer", "reEditAuthority", "reEditCustoms"].includes(model.refStatus?.key)) })]
    };
};

export const createRulesTab1 = ({ data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return {
        [`${prefix}refDepartment`]: [required],
        [`${prefix}refHcTemp.refUserCompany`]: [requiredWhen({ when: () => true, requiredValidator: () => model.refHcTemp.refUserCompany?.id })],
        [`${prefix}refHcTemp.refUser`]: [requiredWhen({ when: () => true, requiredValidator: () => model.refHcTemp.refUser?.id })]
    };
};

export const createRulesTab2 = ({ data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    const rules = {
        [`${prefix}refHcTemp.refInform`]: [required],
        [`${prefix}refHcTemp.manufacturerEn`]: [required],
        [`${prefix}refHcTemp.tradeNameEn`]: [required],
        [`${prefix}refHcTemp.receiveName`]: [required],
        [`${prefix}refHcTemp.receiveAddrEn`]: [required],
        [`${prefix}refHcTemp.portOfDischarge`]: [required],
    };

    model?.refHcTemp?.addresses?.forEach((item, index) => {
        if (item.isDelete !== true) {
            // rules[`${prefix}refHcTemp.addresses.${index}.noEn`] = [required];
            rules[`${prefix}refHcTemp.addresses.${index}.refProvince`] = [required];
            rules[`${prefix}refHcTemp.addresses.${index}.refAmphur`] = [required];
            rules[`${prefix}refHcTemp.addresses.${index}.refTambon`] = [required];
            rules[`${prefix}refHcTemp.addresses.${index}.postCode`] = [required];
        }
    });

    model?.refHcTemp?.products?.forEach((item, index) => {
        if (item.isDelete !== true) {
            rules[`${prefix}refHcTemp.products.${index}.isHc`] = [
                {
                    validator: () => {
                        if (model?.refHcTemp?.products.every(product => !product.isHc)) {
                            return Promise.reject(i18n.global.t("error.form.required"));
                        }
                        const validateNames = model?.refHcTemp?.products
                            .map((item2, index2) => {
                                if (index !== index2) return `${prefix}refHcTemp.products.${index2}.isHc`;
                            })
                            .filter(item2 => item2);
                        data.useForm.clearValidate(validateNames);
                        return Promise.resolve();
                    },
                    trigger: "change"
                }
            ];
        }
    });
    model?.refHcTemp?.declarations?.forEach((item, index) => {
        if (item.isDelete !== true) {
            rules[`${prefix}refHcTemp.declarations.${index}.isCheck`] = [
                {
                    validator: () => {
                        if (model?.refHcTemp?.declarations.every(declaration => !declaration.isCheck)) {
                            return Promise.reject(i18n.global.t("error.form.requiredLeastOne"));
                        }
                        const validateNames = model?.refHcTemp?.declarations
                            .map((item2, index2) => {
                                if (index !== index2) return `${prefix}refHcTemp.declarations.${index2}.isCheck`;
                            })
                            .filter(item2 => item2);
                        data.useForm.clearValidate(validateNames);
                        return Promise.resolve();
                    },
                    trigger: "change"
                }
            ];
        }
    });
    return rules;
};

export const createRulesTab3 = ({ data, key }) => {
    const modelRef = data.useForm?.modelRef || data.form;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    const rules = {};
    model?.refHcTemp?.attachments?.forEach((item, index) => {
        if (item.isDelete !== true) {
            rules[`${prefix}refHcTemp.attachments.${index}.documentName`] = [required];
            rules[`${prefix}refHcTemp.attachments.${index}.size`] = [
                requiredWhen({
                    when: () =>
                        model.refHcTemp.attachments[index].attribute?.isRequiredAttachment || model.refHcTemp.attachments[index].attribute?.documentNo
                })
            ];
        }
    });
    return rules;
};

export const loadDefaultForm = ({ props, data }) => {
    const { form, forceDefault } = props;
    const { id, useForm } = data;
    const { modelRef } = useForm;
    const promises = [
        callHcAttachment({}),
        callRequestStatus({}),
        callRequestType({}),
        callRequestDoc({}),
        callRequestDocGenType({}),
        callAddressType({}),
        callLicenseHcTerms({})
    ];
    return Promise.all(promises).then(arr => {
        data.hcAttachments = arr[0];
        data.statuses = arr[1];
        data.requestTypes = arr[2];
        data.requestDocs = arr[3];
        data.requestDocGenTypes = arr[4];
        data.addressTypes = arr[5];
        data.licenseHcTermses = arr[6];
        const userInfo = store.state.resource.auth.info?.user;

        if ((!id && !form) || forceDefault) {
            modelRef.isOfficerCreate = !!userInfo.refOfficerLv;
            modelRef.lastStatus.draft[0].statusDatetime = moment().format("YYYY-MM-DD[T]HH:mm:ssZ");
            data.hcAttachments.forEach(item =>
                modelRef.refHcTemp.attachments.push({ documentName: item.value, attribute: lodash.cloneDeep(item.attribute) })
            );
            data.licenseHcTermses.forEach(item => modelRef.refHcTemp.declarations.push({ name: item.value, refDeclaration: item }));
            modelRef.refHcTemp.addresses = [{ ...createFormAddress(), refAddressType: data.addressTypes.find(d => d.key === "1") }];
            modelRef.refRequestType = data.requestTypes.find(d => d.key === "1");
            modelRef.refRequestDoc = data.requestDocs.find(d => d.key === "23");
            modelRef.refDocGenType = data.requestDocGenTypes.find(d => d.key === "1");
            if (!modelRef.isOfficerCreate) {
                callUserCompanyMe({}).then(userCompanies => {
                    const refUserCompany = userCompanies[0];
                    modelRef.refHcTemp.refUserCompany = refUserCompany;
                    if (refUserCompany) {
                        callUser({ userCompanyId: refUserCompany.id }).then(
                            users => (modelRef.refHcTemp.refUser = users.find(d => d.id === store.state.resource.auth.info?.user?.id))
                        );
                    }
                });
            }
        }
    });
};

export const loadForm = ({ props, data, refs }) => {
    setIsLoading(true);
    const { form } = props;
    const { id, useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else if (id) {
        promise = callSearch({ criteria: createSearchOneCriteria({ props, data, refs, id }) });
    } else {
        promise = Promise.resolve({ data: [useForm.modelRef] });
    }
    return promise
        .then(page => initUseForm({ props, data, refs, page }))
        .then(() => loadDefaultForm({ props, data, refs }))
        .then(() => initUseForm({ props, data, refs, page: { data: [modelRef] } }))
        .finally(() => setIsLoading(false));
};

export const createAppPageHeaderDefault = ({ props, data, refs, state }) => {
    const col1 = [];
    const col2 = [];
    const { menuContext, viewOnly, routerPrefix } = props;
    const { useForm } = data;
    const { modelRef, initialModel } = useForm;
    const { id, isActive } = modelRef;
    const canEdit = state.conditionAction.canEdit({ props, record: initialModel });
    const canWaitReceive = state.conditionAction.canWaitReceive({ props, record: initialModel });
    const canWaitApprove = state.conditionAction.canWaitApprove({ props, record: initialModel });
    //const canApprove = state.conditionAction.canApprove({ props, record: initialModel });
    const canConfirm = state.conditionAction.canConfirm({ props, record: initialModel });
    const canDelete = state.conditionAction.canDelete({ props, record: initialModel });
    if (id && has({ menuContext, key: "canCreate" })) {
        col1.push(createButtonCreate({ onClick: () => onClickCreate({ routerPrefix }), classStyle: "m-1" }));
    }
    if (!viewOnly && id && has({ menuContext, key: "canView" })) {
        col1.push(createButtonView({ onClick: () => onClickView({ record: { id }, routerPrefix }), classStyle: "m-1" }));
    }
    if (viewOnly && id && isActive && canEdit) {
        col1.push(createButtonEdit({ onClick: () => onClickEdit({ record: { id }, routerPrefix }), classStyle: "m-1" }));
    }
    if (!viewOnly && (!id || (id && isActive && canEdit))) {
        col1.push(
            createButtonSave({
                onClick: () => {
                    data.sendReceive = false;
                    const refHcTemp = modelRef.refHcTemp;
                    let statusRemark = null;
                    if ([undefined, "draft", "reEditOfficer", "reEditAuthority", "reEditCustoms"].includes(initialModel.refStatus?.key)) {
                        statusRemark = modelRef.lastStatus.forRequestRemark[0].remark;
                    } else if (["waitReceive", "waitResponseCustoms", "waitApprove", "waitPayment"].includes(initialModel.refStatus?.key)) {
                        statusRemark = modelRef.lastStatus.forReceiveRemark[0].remark;
                    }
                    onClickSave({
                        props,
                        data,
                        refs,
                        state,
                        formParams: {
                            refHcTemp: {
                                ...modelRef.refHcTemp,
                                refUserCompany: refHcTemp?.refUserCompany?.id ? refHcTemp?.refUserCompany : null,
                                refUser: refHcTemp?.refUser?.id ? refHcTemp?.refUser : null
                            },
                            statusRemark
                        }
                    });
                },
                classStyle: "m-1"
            })
        );
    }
    if (id && isActive && canWaitReceive) {
        const statusWaitReceive = data.statuses.find(status => status.key === "waitReceive");
        col1.push(
            createButton({
                text: `${viewOnly ? "" : `${i18n.global.t("button.save")} & `}${statusWaitReceive?.attribute?.actionText}`,
                classStyle: `m-1 ${statusWaitReceive?.attribute?.btnClass}`,
                onClick: () => {
                    data.sendReceive = true;
                    validate({ props, data, refs }).then(() => {
                        openModalFormConfirmRequest({
                            onOk: record => {
                                const refHcTemp = modelRef.refHcTemp;
                                onClickSave({
                                    props,
                                    data,
                                    refs,
                                    state,
                                    formParams: {
                                        refHcTemp: {
                                            ...modelRef.refHcTemp,
                                            refUserCompany: refHcTemp?.refUserCompany?.id ? refHcTemp?.refUserCompany : null,
                                            refUser: refHcTemp?.refUser?.id ? refHcTemp?.refUser : null
                                        },
                                        statusRemark: modelRef.lastStatus.forReceiveRemark[0].remark,
                                        statusRemarkBefore: modelRef.lastStatus.forRequestRemark[0].remark,
                                        refStatus: statusWaitReceive,
                                        isSignCa: record.isSignCa,
                                        passwordCa: record.passwordCa
                                    },
                                    successText: i18n.global.t("views.request.modal.request.sendSuccess")
                                });
                            }
                        });
                    });
                },
                icon: viewOnly ? null : <CIcon file="save.svg"></CIcon>
            })
        );
    }
    if (id && isActive && canWaitApprove) {
        const statusWaitApprove = data.statuses.find(status => status.key === "waitApprove");
        col1.push(
            createButton({
                text: `${viewOnly ? "" : `${i18n.global.t("button.save")} & `}${i18n.global.t("button.sendRequest")}`,
                classStyle: `m-1 ${statusWaitApprove?.attribute?.btnClass}`,
                onClick: () => {
                    data.sendReceive = true;
                    validate({ props, data, refs }).then(() => {
                        openModalFormConfirmReceive({
                            props: {
                                statusKeys: ["draft"].includes(initialModel.refStatus?.key) ? ["waitApprove"] : [],
                                statusDisabledKeys: ["waitReceive"].includes(initialModel.refStatus?.key) && modelRef.refHcTemp?.refInform?.refInspection?.refSequestrate?.key === "1" ? ["waitApprove"] : [],
                                statusLabelKey: "attribute.actionHcText",
                                visibleRefToApproveBy: false
                            },
                            onOk: record => {
                                const isStatusBack = ["reEditOfficer", "reEditAuthority", "reEditCustoms"].includes(record.refStatus?.key);
                                const refToApproveBy = store.state.resource.auth.info?.user;
                                onClickSave({
                                    props,
                                    data,
                                    refs,
                                    state,
                                    formParams: {
                                        statusRemark: isStatusBack
                                            ? modelRef.lastStatus.forRequestRemark[0].remark
                                            : modelRef.lastStatus.forReceiveRemark[0].remark,
                                        statusRemarkBefore: isStatusBack ? modelRef.lastStatus.forReceiveRemark[0].remark : null,
                                        refStatus: record.refStatus,
                                        refToApproveBy: refToApproveBy,
                                        refHcTemp: { ...modelRef.refHcTemp, refInspectionLv: record.refInspectionLv }
                                    },
                                    successText: i18n.global.t(`views.request.modal.receive.${record.refStatus?.key}2`)
                                });
                            }
                        });
                    });
                },
                icon: viewOnly ? null : <CIcon file="save.svg"></CIcon>
            })
        );
    }
    /*
    if (id && isActive && canApprove) {
        const statusApprove = data.statuses.find(status => status.key === "approve");
        col1.push(
            createButton({
                text: `${viewOnly ? "" : `${i18n.global.t("button.save")} & `}${i18n.global.t("button.sendRequest")}`,
                classStyle: `m-1 ${statusApprove?.attribute?.btnClass}`,
                onClick: () => {
                    data.sendReceive = true;
                    validate({ props, data, refs }).then(() => {
                        openModalFormConfirmApprove({
                            onOk: record => {
                                const isStatusBack = ["reEditOfficer", "reEditAuthority", "reEditCustoms"].includes(record.refStatus?.key);
                                onClickSave({
                                    props,
                                    data,
                                    refs,
                                    state,
                                    formParams: {
                                        statusRemark: isStatusBack
                                            ? modelRef.lastStatus.forRequestRemark[0].remark
                                            : modelRef.lastStatus.forReceiveRemark[0].remark,
                                        statusRemarkBefore: isStatusBack ? modelRef.lastStatus.forReceiveRemark[0].remark : null,
                                        refStatus: record.refStatus
                                    },
                                    successText: i18n.global.t(`views.request.modal.approve.${record.refStatus?.key}`)
                                });
                            }
                        });
                    });
                },
                icon: viewOnly ? null : <CIcon file="save.svg"></CIcon>
            })
        );
    }
    */
    if (id && isActive && canConfirm) {
        col1.push(
            createButton({
                text: i18n.global.t("views.request.hcInfo.accept"),
                classStyle: `m-1 btn-purple`,
                onClick: () => {
                    data.sendReceive = true;
                    validate({ props, data, refs }).then(() => {
                        openModalFormConfirmConfirm({
                            onOk: res => {
                                return validate({ props, data, refs }).then(() => {
                                    setIsLoadingApp(true);
                                    return callConfirmHc({ data: { id: data.useForm.modelRef.id, refStatus: res.refStatus } })
                                        .finally(() => setIsLoadingApp(false))
                                        .then(record => {
                                            notification["success"]({ message: res.refStatus?.attribute?.actionText });
                                            if (viewOnly) initForm({ props, data, refs, state });
                                            else onClickView({ record, routerPrefix });
                                        });
                                });
                            }
                        });
                    });
                }
            })
        );
    }
    if (viewOnly && id && !isActive && has({ menuContext, key: "canActive" })) {
        col2.push(
            createButtonActive({
                onClick: () =>
                    onClickActive({
                        record: { id },
                        callActive,
                        setIsLoading: setIsLoadingApp,
                        onClickEdit: () => onClickEdit({ record: { id }, routerPrefix })
                    }),
                classStyle: "m-1"
            })
        );
    }
    if (!viewOnly && id && isActive && has({ menuContext, key: "canArchive" })) {
        col2.push(
            createButtonArchive({
                onClick: () =>
                    onClickArchive({
                        record: { id },
                        callArchive,
                        setIsLoading: setIsLoadingApp,
                        onClickView: () => onClickView({ record: { id }, routerPrefix })
                    }),
                classStyle: "m-1"
            })
        );
    }
    if (!viewOnly && id && isActive && canDelete) {
        col2.push(
            createButtonDelete({
                onClick: () => onClickDelete({ record: { id }, callDelete, setIsLoading: setIsLoadingApp, state, routerPrefix }),
                classStyle: "m-1"
            })
        );
    }
    return (
        <Row type="flex">
            <Col>{col1}</Col>
            <Col class="ml-auto">{col2}</Col>
        </Row>
    );
};

export const initForm = ({ props, data, refs, state }) => {
    const { routerPrefix } = props;
    checkAttribute({ props, data, refs });
    data.form = createForm({ props, data, refs });
    data.rules = createRules({ props, data, refs });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs, isLoading });
    data.conditionForms = createConditionForm({ props, data, refs, isLoading });
    data.userInfo = store.state.resource.auth.info?.user;
    watchRulesChildren({
        props,
        data,
        refs,
        trigger: () => ({
            length1: data.useForm.modelRef.refHcTemp.addresses.filter(d => d.isDelete !== true).length,
            length2: data.useForm.modelRef.refHcTemp.products.filter(d => d.isDelete !== true).length,
            length3: data.useForm.modelRef.refHcTemp.declarations.filter(d => d.isDelete !== true).length
        }),
        createRules: () => createRulesTab2({ props, data, refs }),
        itemsKey: ["refHcTemp.addresses", "refHcTemp.products", "refHcTemp.declarations"]
    });
    watchRulesChildren({
        props,
        data,
        refs,
        trigger: () => data.useForm.modelRef.refHcTemp.attachments.filter(d => d.isDelete !== true).length,
        createRules: () => createRulesTab3({ props, data, refs }),
        itemsKey: "refHcTemp.attachments"
    });
    loadForm({ props, data, refs }).then(() => {
        if (props.setAppPageHeader) {
            setAppPageHeader({
                slots: {
                    top: () => createAppPageHeaderTop({ props, data, refs, state, routerPrefix, onClickView, onClickEdit }),
                    default: () => createAppPageHeaderDefault({ props, data, refs, state })
                }
            });
        }
    });
};

export const initState = ({ props }) => {
    const { menuContext, routerPrefix } = props;
    const stateKey = `${routerPrefix}`;
    if (stateGroup[stateKey]) {
        return stateGroup[stateKey];
    }
    const state = {
        columns: createColumns({ props }),
        page: createPage({
            options: {
                select: [
                    "*",
                    "refHc.*",
                    "refHcTemp.*",
                    "refHcTemp.refUserCompany.*",
                    "refHcTemp.refUserCompany.refPersonType.*",
                    "refHcTemp.refUser.*",
                    "refHcTemp.refInform.approveCode",
                    "refHcTemp.refInform.createDate",
                    "refRequestType.*",
                    "refStatus.*"
                ],
                sort: [/* { name: "refStatus.seq", type: "ASC" } ,*/ { name: "updateDate", type: "DESC" }],
                children: [
                    {
                        name: "refHcTemp.products",
                        select: [
                            "id",
                            "refInformProduct.id",
                            "refInformProduct.refHaz.id",
                            "refInformProduct.refHaz.approveCode",
                            "refInformProduct.refHaz.tradeNameTh"
                        ],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }]
                    }
                ]
            }
        }),
        tableOptions: { search: { activeKey: "Search" } },
        conditionAction: createConditionAction()
    };
    state.manages = [
        createManageSelect({ menuContext }),
        createManageActive({
            menuContext,
            onClick: ({ rowSelection }) =>
                onClickActiveAll({ rowSelection, callActiveAll, state, onSearch: search => onSearch({ props, state, ...search }), setIsLoading }),
            confirm: ({ rowSelection }) => ({ content: rowSelection.selectedRows.map(d => d.draftCode).join(", ") })
        }),
        createManageArchive({
            menuContext,
            onClick: ({ rowSelection }) =>
                onClickArchiveAll({ rowSelection, callArchiveAll, state, onSearch: search => onSearch({ props, state, ...search }), setIsLoading }),
            confirm: ({ rowSelection }) => ({ content: rowSelection.selectedRows.map(d => d.draftCode).join(", ") }),
            getCheckboxProps: ({ record }) => ({ disabled: !state.conditionAction.canArchive({ props, record }) })
        }),
        createManageDelete({
            menuContext,
            onClick: ({ rowSelection }) =>
                onClickDeleteAll({ rowSelection, callDeleteAll, state, onSearch: search => onSearch({ props, state, ...search }), setIsLoading }),
            confirm: ({ rowSelection }) => ({ content: rowSelection.selectedRows.map(d => d.draftCode).join(", ") }),
            getCheckboxProps: ({ record }) => ({ disabled: !state.conditionAction.canDelete({ props, record }) })
        }),
        createManageExportCsv({ menuContext })
    ];
    state.manageExtras = [createManageExtraCreate({ menuContext, onClick: () => onClickCreate({ routerPrefix }) })];
    state.rowActions = [
        createRowActionView({ menuContext, onClick: ({ record }) => onClickView({ record, routerPrefix }) }),
        createRowActionEdit({
            menuContext,
            onClick: ({ record }) => onClickEdit({ record, routerPrefix }),
            visible: ({ record }) => state.conditionAction.canEdit({ props, record })
        }),
        createRowActionEdit({
            bind: { class: "btn-purple", size: "small", icon: () => <CIcon file="signature.svg"></CIcon> },
            text: () => i18n.global.t("views.request.hcInfo.accept"),
            showText: () => false,
            menuContext,
            onClick: ({ record }) => onClickView({ record, routerPrefix }),
            visible: ({ record }) => state.conditionAction?.canConfirm({ props, record })
        }),
        createRowActionReStatus({
            menuContext,
            onClick: ({ record }) => {
                Modal.confirm({
                    title: i18n.global.t("components.table.operatorAndPagination.youAreWant", { text: i18n.global.t("button.reStatus") }),
                    autoFocusButton: "cancel",
                    onOk: () => {
                        setIsLoadingApp(true);
                        callReStatus({ data: record })
                            .finally(() => setIsLoadingApp(false))
                            .then(() => onSearch({ props, state, page: state.page }));
                    }
                });
            },
            visible: ({ record }) => state.conditionAction.canReStatus({ props, record })
        }),
        /*
        createRowActionPdf({
            bind: { class: "btn-primary", size: "small", icon: () => <CIcon file="search.svg"></CIcon> },
            text: () => i18n.global.t("button.viewRequestDocument"),
            callReport: ({ record }) => callReportHc({ data: { id: record.id } }),
            fileName: "report.pdf"
        })
        */
        createRowActionOpenUrl({
            bind: { class: "btn-primary", size: "small", icon: () => <CIcon file="search.svg"></CIcon> },
            text: () => i18n.global.t("button.viewRequestDocument"),
            callUrl: ({ record }) => `${process.env.VUE_APP_API_REPORT_URL}/files/haz/company/${record.id}/file-result.pdf?contentDisposition=inline&_timestamp=${new Date().getTime()}`,
            visible: ({ record }) => state.conditionAction.canReport({ props, record })
        })
    ];
    return (stateGroup[stateKey] = state);
};

export const stateGroup = [];
